import React from "react";

// Замени на реальные контакты поддержки.
const SUPPORT_WHATSAPP = "77779702298"; // международный формат, без "+", пробелов и скобок
const SUPPORT_TELEGRAM = "rzamaldinov"; // без "@"
const SUPPORT_EMAIL = "zamaldinov.raphael@gmail.com";

const buttonStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  padding: "12px 16px",
  borderRadius: "10px",
  border: "none",
  background: "#f5f5f5",
  cursor: "pointer",
  fontSize: "14px",
  fontWeight: 500,
  color: "#1a1a1a",
  width: "100%"
};

function SupportModal({ set }) {
  const handleClose = () => set(false);

  const openWhatsApp = () => {
    const text = encodeURIComponent("Здравствуйте! У меня вопрос по приложению Атырау Жарык.");
    window.open(`https://wa.me/${SUPPORT_WHATSAPP}?text=${text}`, "_blank");
  };

  const openTelegram = () => {
    window.open(`https://t.me/${SUPPORT_TELEGRAM}`, "_blank");
  };

  const openEmail = () => {
    const subject = encodeURIComponent("Вопрос по приложению Атырау Жарык");
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}`;
  };

  return (
    <div style={{ padding: "8px", minWidth: "260px" }}>
      <p style={{ fontSize: "16px", fontWeight: 600, marginBottom: "16px", textAlign: "center" }}>
        Связаться с поддержкой
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <button style={buttonStyle} onClick={openWhatsApp}>WhatsApp (+{SUPPORT_WHATSAPP})</button>
        <button style={buttonStyle} onClick={openTelegram}>Telegram (@{SUPPORT_TELEGRAM})</button>
        <button style={buttonStyle} onClick={openEmail}>Почта ({SUPPORT_EMAIL})</button>
        <button
          style={{ ...buttonStyle, background: "transparent", color: "#888" }}
          onClick={handleClose}
        >
          Отменить
        </button>
      </div>
    </div>
  );
}

export default SupportModal;
